import headers from './headers';
import request from './request';


/**
 * Класс для работы с subrequest
 *
 * @param obj
 * @returns str
 */
class SubrequestApi {
  constructor(props) {
    this.objPost = [];
    // Добавление куков к запросу
    this.cookie = props && props.req && props.req.headers.cookie ? props.req.headers.cookie : '';
    this.require = [];
  }

  /**
   * Преобразует объект в строку гет параметров
   *
   * @param obj
   * @returns {string}
   */
  toStr(obj) {
    let str = '';
    const keys = Object.keys(obj);
    keys.forEach((key) => {
      str += str === '' ? `${key}=${obj[key]}` : `&${key}=${obj[key]}`;
    });

    return str;
  }

  /**
   * Добавляет подзапрос к запросу
   *
   * @param url - урл для подзапроса
   * @param queryObj - объект с параметрами для запроса (include, fields, sort и т.д)
   * @param nameRequest - название подзапроса
   * @param waitFor - название запроса которого нужно дождатся до выполнения текущего
   */
  addSubRequest({ url, queryObj, requestId, waitFor, require, jsonapi }) {
    if (url && requestId) {
      let subrequest = {
        action: 'view',
        requestId,
      };

      // Добавляем обязательный ответ от сервера (если этот запрос не отработает без ошибок - то возвращаем код ошибки или 500)
      if (require) this.require.push(requestId);

      const queryStr = queryObj ? `?${this.toStr(queryObj)}` : '';

      // Добавляем waitFor если нужно дождатся выполнение запроса
      if (waitFor) subrequest.waitFor = waitFor;
      // Добавляем к урлу гет параметры.
      subrequest.uri = url + queryStr;
      if (jsonapi) {
        subrequest = this.setHeaders(subrequest);
      }

      this.objPost.push(subrequest);
    } else {
      console.log('При использовании subrequest не передан url или nameRequest - поэтому подзапрос не был добавлен');
    }
  }

  /**
   * Добавление к подзапросу заголовков
   *
   * @param subRequest
   * @returns {*}
   */
  setHeaders(subRequest) {
    subRequest.headers = headers;
    return subRequest;
  }

  /**
   * Отправка запроса со всеми подзапросами
   *
   * Возвращает undefined если произошла ошибка запроса
   * @returns {Promise.<*>}
   */
  async send() {
    let response;
    try {
      // Добавляем куки к запросу.
      if (typeof window === 'undefined') request.set('Cookie', this.cookie);
      response = await request
        .post('/subrequests?_format=json')
        .send(this.objPost);

      response = response.statusCode === 207 ? response : { error: 500 };

    } catch (e) {
      response = { error: 500 };
    }
    // Если ответ от сервера пришёл без ошибки - нормализуем ответ.
    if (!response.error) {
      response = this.clearResponse(response);
    } else {
      console.log(response);
    }
    return response;
  }

  /**
   * Возвращает объект с ключами равными именам подзапросов
   *
   * @param response
   * @returns {{}}
   */
  clearResponse(response) {
    const newResponse = {};

    Object.keys(response.body).forEach((key) => {
      // Normalize key for decoupled_route
      const newKey = key.replace('#uri{0}', '');
      // Normalize response.
      newResponse[newKey] = JSON.parse(response.body[key].body);
    });
    // Проверяем все ли require запросы отработали без ошибок.
    return this.checkRequireResponse(newResponse);
  }

  checkRequireResponse(response) {
    let error = false;
    this.require.some((nameRequest) => {
      if (!response[nameRequest]) {
        // Устанавливаем ошибку 500 если нет ответа от require запроса.
        error = 500;
        return error;
      } else if (nameRequest === 'router' && !('jsonapi' in response[nameRequest])) {
        // Устанавливаем ошибку 404 если router не нашёл такой урл.
        error = 404;
        return error;
      } else if (response[nameRequest].errors) {
        // Устанавливаем ошибку из ответа если запрос require вуернул ошибку.
        error = response[nameRequest].errors[0].status;
        return error;
      }
    });

    if (error) response.error = error;
    return response;
  }
}

export default SubrequestApi;
